export const VALIDATE_AUTH_WITH_CACHE = 'VALIDATE_AUTH_WITH_CACHE'
export const validateAuth = (payload) => ({
  type: VALIDATE_AUTH_WITH_CACHE,
  payload,
})

export const AUTH_COOKIE_SET = 'AUTH_COOKIE_SET'
export const authCookieSet = () => ({ type: AUTH_COOKIE_SET })
